<template>
  <v-container
    fluid
    :class="{
      'px-0': !packageMode,
      'py-0': !packageMode,
      block: packageMode && !bankMode,
      isBlocked: !editMode,
    }"
  >
    <loading v-if="!documentsData && !documentsData.length" />

    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex
            xs12
            documents
            :class="{
              'documents--nobuttons':
                (status === 0 && userRole === 0) ||
                (status === 50 && userRole === 10) ||
                status > 150,
            }"
          >
            <v-layout
              row
              wrap
              documents__download
              v-if="!publicMode && userRole === 170"
            >
              <v-flex xs12>
                <v-btn
                  @click="downloadZip"
                  color="primary"
                  :loading="isDownloadZip"
                  class="ma-0 mb-4"
                  outlined
                >
                  <v-icon color="primary" class="mr-2" size="20px"
                    >archive</v-icon
                  >{{ $t("components.client.documents.downloadAllDocuments") }}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-form ref="form" v-model="valid">
              <table>
                <tbody
                  v-for="(documentFolder, idx, key) in documentsData"
                  :key="`document_folder_${idx}`"
                >
                  <tr v-if="!bankMode || idx === 3">
                    <td colspan="5">
                      <h3>{{ documentFolder.name }} {{ key }}</h3>
                    </td>
                  </tr>

                  <tr
                    v-for="(document, idxi) in documentFolder.folders"
                    :key="'document' + idxi"
                    :class="{
                      documents__row: true,
                      documents__uploaded: !bankMode && document.document,
                      new: isDocumentUpdated(document),
                      documents__hide: bankMode && !document.document,
                      'read-only': !editMode,
                    }"
                  >
                    <td>{{ document.idx }}</td>
                    <td>
                      {{ document.name }}
                      <a
                        download
                        :href="getExampleLink()"
                        class="documents__example"
                        v-if="document.id === 18"
                        >{{$t("components.client.documents.downloadTemplate")}}</a>
                      <tips tipId />
                      <div class="documents__file">
                        {{
                          document.document &&
                          document.document.file &&
                          document.document.file.name
                            ? $t("components.client.documents.downloadedFile", {
                                name: document.document.file.name,
                              }) 
                            : ""
                        }}
                      </div>
                    </td>

                    <td class="text-right" v-if="!packageMode">
                      <span
                        v-if="document.document && document.document.status"
                      >
                        <!-- {{ getStatusName(document.document.status) }} -->
                      </span>
                      <span class="status status__none" v-else>{{
                        $t("components.client.documents.noDownloaded")
                      }}</span>
                    </td>
                    <td v-else></td>

                    <td class="documents__info text-right">
                      <v-btn
                        class="documents__icon"
                        v-if="!packageMode && document.moderator_comment"
                        text
                        icon
                      >
                        <div class="tip">
                          <div class="tip__wrapper">
                            <div class="tip__item">
                              <v-icon color="red">message</v-icon>
                            </div>
                            <div class="tip__body">
                              {{ document.moderator_comment }}
                            </div>
                          </div>
                        </div>
                      </v-btn>

                      <v-btn
                        v-if="
                          document.document &&
                            document.document.file &&
                            isImage(document.document.file.mime_type)
                        "
                        :class="{ documents__icon: true }"
                        @click="viewFile(document.document)"
                        :title="$t('components.client.documents.viewFile')"
                        text
                        icon
                      >
                        <v-icon>image_search</v-icon>
                      </v-btn>

                      <v-btn
                        v-if="document.document && document.document.file"
                        :class="{ documents__icon: true }"
                        @click="getFile(document.document)"
                        :title="$t('components.client.documents.downloadFile')"
                        text
                        icon
                      >
                        <v-icon>save_alt</v-icon>
                      </v-btn>

                      <v-btn
                        :class="{
                          documents__icon: true,
                          'documents__inactive-upload': document.file,
                        }"
                        @click="openFileDialog(document)"
                        :title="$t('components.client.documents.updateFile')"
                        v-if="isSave && (!packageMode || editMode)"
                        text
                        icon
                      >
                        <v-icon
                          color="primary"
                          v-if="document.document && document.document.file"
                          >autorenew</v-icon
                        >
                        <!--cloud_upload-->
                        <v-icon v-else color="primary">mdi-paperclip</v-icon>
                      </v-btn>

                      <delete-dialog
                        :deleteButton="{
                          type: 'icon',
                          value: 'delete',
                          iconColor: 'error',
                        }"
                        :item-name="document.name"
                        v-on:deleteEntry="deleteCustomFile(document)"
                        v-if="
                          !publicMode &&
                            ((!packageMode && idx === 3) ||
                              (editMode && idx === 3))
                        "
                      />
                    </td>
                  </tr>

                  <tr v-if="documentFolder.id == 4">
                    <td colspan="4">
                      <em
                        v-if="
                          isSave &&
                            documentFolder.folders &&
                            !documentFolder.folders.length
                        "
                        class="documents__empty"
                        >{{ $t("components.client.documents.noDocuments") }}</em
                      >
                      <span
                        @click="addCustomFile(documentFolder)"
                        class="add-link documents__add"
                        v-if="
                          isSave &&
                            ((!packageMode && documentFolder.id === 4) ||
                              (editMode && documentFolder.id === 4))
                        "
                      >
                        <!--cloud_upload-->
                        <v-icon>mdi-paperclip</v-icon>{{ dopButtonName }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-form>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="modal"
      transition="slide-x-reverse-transition"
      max-width="666"
      content-class="image_preview"
    >
      <h2 class="mb-4">{{ uploadFieldName }}</h2>
      <loading v-if="!img" />
      <img :src="img" v-else />
    </v-dialog>

    <v-dialog v-model="fileDialog" width="500" persistent>
      <v-layout row wrap modal__block>
        <span class="modal__close" @click="closeModal"></span>
        <v-flex xs12 modal__wrapper>
          <form
            enctype="multipart/form-data"
            novalidate
            v-if="isInitial || isSaving"
          >
            <h2 class="mb-2" v-if="!isCustomFile">{{ uploadFieldName }}</h2>
            <div class="help_tip mb-4" v-if="uploadFieldTip">
              {{ uploadFieldTip }}
            </div>
            <v-text-field
              v-model="uploadFieldName"
              :label="$t('components.client.documents.fileDialog.filename')"
              v-if="isCustomFile"
            ></v-text-field>
            <transition name="slide-fade" mode="in-out">
              <div
                :class="{
                  dropbox: true,
                  'dropbox--blocked':
                    !uploadFieldName || !uploadFieldName.length,
                }"
              >
                <input
                  type="file"
                  multiple
                  :name="uploadFieldName"
                  :disabled="
                    (!uploadFieldName && !uploadFieldName.length) || isSaving
                  "
                  @change="filesChange($event.target.name, $event.target.files)"
                  class="input-file"
                />
                <p v-if="isInitial">
                  <template v-if="uploadFieldName && uploadFieldName.length">
                    <span
                      v-html="
                        $t(
                          'components.client.documents.fileDialog.moveFileHtml'
                        )
                      "
                    ></span>
                  </template>

                  <template v-else>
                    <span
                      v-html="
                        $t(
                          'components.client.documents.fileDialog.pleaseNameFileHtml'
                        )
                      "
                    ></span>
                  </template>
                </p>
                <p class="pt-1" v-if="isInitial">
                  <v-icon color="error" class="mr-2">warning</v-icon
                  >{{
                    $t("components.client.documents.fileDialog.warningTitle")
                  }}
                  <v-icon color="error" class="ml-2">warning</v-icon>
                  <br />{{
                    $t("components.client.documents.fileDialog.warningText")
                  }}
                </p>
                <p v-if="isSaving">
                  {{ $t("components.client.documents.fileDialog.loading") }}
                </p>
              </div>
            </transition>
          </form>

          <div v-if="isSuccess">
            <h1>
              {{ $t("components.client.documents.fileDialog.loadSuccess") }}
            </h1>
          </div>

          <div v-if="isFailed">
            <h1 class="mb-3">
              {{ $t("components.client.documents.fileDialog.errorLoadTitle") }}
            </h1>

            <h3
              v-for="(error, idx) in uploadError"
              :key="`error_${idx}`"
              class="error--text"
            >
              {{ error }}
            </h3>
            <p class="mt-5">
              <a href="javascript:void(0)" @click="reset()">{{
                $t("components.client.documents.fileDialog.again")
              }}</a>
            </p>
          </div>
        </v-flex>
      </v-layout>
    </v-dialog>
  </v-container>
</template>

<script>
import tips from "@/components/lib/tips";
import statusNames from "@/utils/data/statuses";
import { apiCallTrue } from "@/utils/api";
import DeleteDialog from "@/components/lib/DeleteDialog";
import showNotify from "@/services/noty";
import {
  uploadDocument,
  uploadPackageDocument,
  uploadCustomPackageDocument,
  uploadPublicDocument,
} from "@/components/lib/file-upload.service";

// import axios from "axios";
import i18n from "@/services/i18n";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "ClientDocuments",
  data: () => ({
    valid: false,
    documentNumber: 1,
    documentsTotal: 0,
    updatedDocuments: [],
    statusNames,
    isLoaded: false,
    fileDialog: false,
    // file uploads
    uploadedFiles: {},
    uploadError: null,
    currentStatus: null,
    uploadFieldName: "",
    uploadFieldTip: "",
    uploadFolderId: null,
    uploadFileId: null,
    img: null,
    modal: false,
    isDownloadZip: false,
    isCustomFile: false,
  }),
  props: {
    documentsData: {
      type: Array,
    },
    packageMode: {
      type: Number,
      default: 0,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    publicMode: {
      type: String,
      default: null,
    },
    bankMode: {
      type: Number,
      default: 0,
    },
    agentMode: {
      type: Number,
      default: 0,
    },
    userRole: {
      type: Number,
      default: 0,
    },
    status: {
      type: Number,
      default: 0,
    },
    dopButtonName: {
      type: String,
      default: i18n.t("components.client.documents.uploadOtherDocument"),
    },
    timeCloseDialog: {
      type: Number,
      default: 2000,
    },
    timeReset: {
      type: Number,
      default: 3000,
    },
    bidStatus: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    getStatusName(id) {
      return this.statusNames.package[id].name || "";
    },
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(formData) {
      this.currentStatus = STATUS_SAVING;
      const config = {
        packageMode: this.packageMode,
        uploadFileId: this.uploadFileId,
        uploadFolderId: this.uploadFolderId,
        inn: this.agentMode,
        hash: this.publicMode,
      };

      if (this.packageMode && !this.isCustomFile) {
        uploadPackageDocument(formData, config)
          .then((response) => {
            if (response.result) {
              this.uploadedFiles = response.data;
              this.currentStatus = STATUS_SUCCESS;
              this.updatedDocuments.push(response.data.id);
              if (this.bankMode) {
                this.$emit(
                  "updateBankPackageDocuments",
                  response.data,
                  this.bankMode
                );
              } else {
                this.$emit("updatePackageDocuments", response.data);
              }
              setTimeout(() => (this.fileDialog = !this.fileDialog), 2000);
              setTimeout(() => this.reset(), 3000);
            } else {
              this.currentStatus = STATUS_FAILED;
              this.uploadError = [];
              this.uploadError[0] = response.message;
            }
          })
          .catch((error) => {
            console.log(error, "errrrrrrrrrrrrrrrr");
            // if (
            //     error &&
            //     error.response &&
            //     error.response.data &&
            //     error.response.data.validation
            // ) {
            //     this.uploadError = error.response.data.validation;
            // } else {
            //     this.uploadError = error;
            // }
            this.uploadError = error;
            this.currentStatus = STATUS_FAILED;
          });
      }
      if (this.packageMode && this.isCustomFile) {
        uploadCustomPackageDocument(formData, config)
          .then((response) => {
            this.uploadedFiles = response.data;
            this.currentStatus = STATUS_SUCCESS;
            this.updatedDocuments.push(response.data.document.file.id);
            this.$emit("updateCustomPackageDocuments", response.data);
            setTimeout(
              () => (this.fileDialog = !this.fileDialog),
              this.timeCloseDialog
            );
            setTimeout(() => this.reset(), this.timeReset);
          })
          .catch((error) => {
            this.uploadError = error.response.data.validation;
            this.currentStatus = STATUS_FAILED;
          });
      }
      if (!this.packageMode && !this.publicMode) {
        uploadDocument(formData, config)
          .then((response) => {
            if (response && response.result) {
              this.uploadedFiles = response.data;
              this.currentStatus = STATUS_SUCCESS;
              this.$emit("updateDocuments");
              setTimeout(() => !this.fileDialog, 2000);
              setTimeout(() => this.reset(), 3000);
            } else {
              this.uploadError = [];
              this.uploadError[0] = response.message;
              this.currentStatus = STATUS_FAILED;
            }
          })
          .catch((error) => {
            this.uploadError = error.response.data.validation;
            this.currentStatus = STATUS_FAILED;
          });
      }
      if (this.publicMode) {
        uploadPublicDocument(formData, config)
          .then((response) => {
            if (response && response.result) {
              this.uploadedFiles = response.data;
              this.currentStatus = STATUS_SUCCESS;
              this.$emit("updateDocuments");
              setTimeout(() => !this.fileDialog, 2000);
              setTimeout(() => this.reset(), 3000);
            } else {
              this.uploadError = [];
              this.uploadError[0] = response.message;
              this.currentStatus = STATUS_FAILED;
            }
          })
          .catch((error) => {
            this.uploadError = error.response.data.validation;
            this.currentStatus = STATUS_FAILED;
          });
      }
    },
    filesChange(fieldName, fileList) {
      const formData = new FormData();

      if (!fileList.length) return;

      // Array.from(Array(fileList.length).keys()).map(x => {
      //     formData.append(fieldName, fileList[x], fileList[x].name);
      // });

      if (this.packageMode) {
        // formData.append("package_id", this.packageMode);
      } else {
        formData.append("folder_id", this.uploadFolderId);
      }

      if (this.isCustomFile) {
        formData.append("name", this.uploadFieldName);
      }

      formData.append("type", 1);
      formData.append("file", fileList[0]);

      this.save(formData);
    },
    async getFile(file) {
      const hash = file.file.hash_id;
      const url = this.publicMode
        ? `v1/files/${file.file.id}/storage-link-public-hash/${this.publicMode}`
        : `v1/files/storage-link/${hash}`;
      this.uploadFieldName = file.name;

      await apiCallTrue({
        url,
      })
        .then((response) => {
          const link = document.createElement("a");
          link.href = response.data.data;
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async viewFile(file) {
      const hash = file.file.hash_id;
      const url = this.publicMode
        ? `v1/files/${file.file.id}/storage-link-public-hash/${this.publicMode}`
        : `v1/files/storage-link/${hash}`;
      this.uploadFieldName = file.name;
      this.modal = true;

      await apiCallTrue({
        url,
      })
        .then((response) => {
          this.img = response.data.data;
          // this.modal = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openFileDialog(item) {
      this.isCustomFile = false;
      this.fileDialog = true;
      this.uploadFieldName = item.name;
      this.uploadFieldTip = this.getFieldTip(item.id);
      this.uploadFolderId = item.id;
      this.uploadError = null;
      if (item.document && item.document.id) {
        this.uploadFileId = item.document.id;
      }
    },
    addCustomFile(item) {
      this.fileDialog = true;
      this.uploadFieldName = "";
      this.isCustomFile = true;
      this.uploadFolderId = item.id;
      this.uploadFileId = item.id;
      this.uploadError = null;
      this.uploadFieldTip = "";
    },
    isImage(extension) {
      if (!extension) return false;
      let output = false;
      switch (extension) {
        case "image/jpg":
        case "image/png":
        case "image/jpeg":
        case "image/gif":
        case "image/bmp":
          output = true;
          break;
      }
      return output;
    },
    setDocumentNumber() {
      if (typeof this.documentsData !== "object") return;
      let total = 0;
      this.documentsData.map((folder) => {
        if (folder.folders && folder.folders.length) {
          folder.folders.map((document) => {
            if (document && !document.idx) {
              document.idx = ++total;
            }
          });
        }
      });
    },
    async downloadZip() {
      this.isDownloadZip = true;
      await apiCallTrue({
        url: `v1/package/${this.packageMode}/compress`,
      })
        .then((response) => {
          if (response.data && response.data.result) {
            const link = document.createElement("a");
            link.href = response.data.data;
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
          } else {
            showNotify("error", response.data.message);
          }
        })
        .catch((error) => {
          showNotify("error", error);
        })
        .finally(() => {
          this.isDownloadZip = false;
        });
    },
    async deleteCustomFile(document) {
      if (this.bankMode || (this.packageMode && this.editMode)) {
        this.$emit("deleteDocument", document);
      } else {
        await apiCallTrue({
          url: `v1/files/delete-custom-folder/${document.id}`,
        })
          .then(() => {
            this.$emit(" ");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    closeModal() {
      this.fileDialog = false;
      this.uploadFieldName = "";
      this.uploadFolderId = "";
      this.uploadFieldTip = "";
    },
    isDocumentUpdated(document) {
      if (
        !document ||
        !document.document ||
        !document.document.file ||
        !document.document.file.id
      )
        return;
      return this.updatedDocuments.includes(document.document.id);
    },
    getTemplate() {
      const link = document.createElement("a");
      link.href = "files/contracts.xlsx";
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
    },
    getFieldTip(id) {
      const tips = {
        5: "Одним файлом, скан всех страниц.",
        6: "Прикрепить решение или протокол, приказ не нужен.",
        7: "Устав организации с отметкой регистрирующего органа, все страницы.",
        8: "Бухгалтерская отчетность форма 1,2 в скане, с печатью и подписью руководителя.",
        9: "Налоговая декларация + квитанция о приеме в налоговом органе.",
        14: "Бухгалтерская отчетность форма 1,2 за 2018 год + квитанция о приеме в налоговом органе.",
        16: "Договор аренды, субаренды помещения, действующий на момент подачи заявки, или свидетельство о праве собственности.",
      };
      return tips[id] ? tips[id] : "";
    },
    getExampleLink() {
      return `${window.location.origin}/files/contracts.xlsx`;
    },
  },
  components: {
    tips,
    DeleteDialog,
  },
  mounted() {
    this.reset();
    if (this.documentsData) {
      this.setDocumentNumber();
    }
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    isSave() {
      if (this.publicMode) {
        if (this.bidStatus == 0) return true;
        if (this.bidStatus == 30) return true;
        return false;
      }
      return true;
    },
  },
  watch: {
    editMode(val) {
      if (!val) {
        this.updatedDocuments = [];
      }
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/scss/_variables";
.documents {
  padding-top: 50px !important;
  position: relative;

  &--nobuttons {
    padding-top: 10px !important;
  }
  &__hide {
    display: none;
  }
  &__row {
    margin-bottom: 16px;
    // transition: background 0.4s ease;

    // &:hover {
    //     background: #f0f0f0;
    // }

    .tip {
      margin-top: 0;
    }
    .status {
      margin-top: 3px;
    }
    &.new {
      background: #e6e8fc;
      font-weight: 700;
      color: #000;
    }
  }
  &__info {
    white-space: nowrap;

    .tip__item {
      background: none;
    }
  }
  // &__icon {
  //     width: 20px;
  //     height: 20px;
  //     display: inline-block;
  //     vertical-align: top;
  //     margin-left: 16px;
  //     cursor: pointer;

  //     svg {
  //         width: 100%;
  //         height: 100%;
  //     }
  // }

  &__file {
    font-style: italic;
    color: #aaa;
  }

  &__example {
    color: $primary !important;
    margin-left: 10px;
    text-decoration: underline;
    font-style: italic;
  }

  &__uploaded:not(.read-only) {
    color: #ccc;
    transition: color 0.4s ease;

    &:hover {
      color: #222;
    }

    .documents__file {
      color: #ccc;
    }
  }
  &__empty {
    color: #aaa;
  }
  &__add {
    margin: 0 0 0 34px !important;
    display: inline-block !important;
    vertical-align: top;
    transition: all 0.3s ease;

    .v-icon {
      font-size: 16px !important;
      margin-right: 5px;
      transition: all 0.3s ease;
      color: $primary !important;
      margin-top: -3px;
    }

    &:hover {
      color: #000 !important;

      .v-icon {
        color: #000 !important;
      }
    }
  }
  &__download {
    // margin-left: 150px !important;
    // margin-top: -40px !important;
    position: absolute;
    top: 8px;
    right: 8px;
    width: 300px;
    text-align: right;
  }
}
</style>
